<style>


.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: white;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.small{
  color: white;
}

.date-container{
  display: grid;
  grid-template-columns: auto;
  color: white;
  text-align: center;
  justify-items: center;
}
.month{
  grid-column: 1;
  padding: 10px 10px;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}
.date{
  grid-column: 2;
  padding: 10px 10px;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}
.year{
  grid-column: 3;
  padding: 10px 10px;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}
.to-young-error{
  color: red;
}

</style>

<Dialog show="{showMonths}" title="Select A Month" height="{400}" buttons="{[{text: 'Cancel', callback: 'cancel', disabled: false, }]}" on:cancel="{ () => showMonths = false }">
  <MonthSelect bind:month="{month}" year="{year}" on:changed="{check}"></MonthSelect>
</Dialog>

<Dialog show="{showDates}" title="Select A Date" height="{500}" buttons="{[{text: 'Cancel', callback: 'cancel', disabled: false, }]}" on:cancel="{ () => showDates = false }">
  <DateSelect bind:date="{date}" month="{month}" year="{year}" on:changed="{check}"></DateSelect>
</Dialog>

<Dialog show="{showYears}" title="Select A Year" height="{500}" buttons="{[{text: 'Cancel', callback: 'cancel', disabled: false, }]}" on:cancel="{ () => showYears = false }">
  <YearSelect bind:year="{year}" on:changed="{check}"></YearSelect>
</Dialog>

<div class="bg">
  <div class="title-signup">When's your birthday?</div>
  
  <div class="margin">
    <div class="date-container">
      <div class="month" on:click="{ () => showMonths = true }">
        <MonthInput month="{month}" year="{year}"></MonthInput>
      </div>
      <div class="date" on:click="{ () => showDates = true }">
        <DateInput date="{date}"></DateInput>
      </div>
      <div class="year" on:click="{ () => showYears = true }">
        <YearInput year="{year}"></YearInput>
      </div>
    </div>
  </div>
  
  <div class="margin small">You must be 18+ to sign up.</div>
  
  {#if toYoungErrorShown}
  <div class="margin to-young-error">Sorry, you're too young to sign up.</div>
  {/if}
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->

<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Dialog from "../../../../components/DialogSlide.svelte";
import MonthInput from "../../../../components/MonthInput.svelte";
import MonthSelect from "../../../../components/MonthSelect.svelte";
import DateInput from "../../../../components/DateInput.svelte";
import DateSelect from "../../../../components/DateSelect.svelte";
import YearInput from "../../../../components/YearInput.svelte";
import YearSelect from "../../../../components/YearSelect.svelte";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("birthdaySaved", false);
  // Signup.saveToPersonalObject("birthday", "");
  birthdaySaved = Signup.getPersonalObject("birthdaySaved");
  birthday = Signup.getPersonalObject("birthday");
  if (birthday != "") {
    let bd = birthday.split("-");
    year = parseInt(bd[0]);
    month = parseInt(bd[1]);
    date = parseInt(bd[2]);
  }
  
  if (birthdaySaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let year = "YYYY";
let month = "MM";
let date = "DD";
let birthday = ""; // mysql style date
let birthdaySaved = false;
let nextDisabled = true;
let toYoungErrorShown = false;

let showMonths = false;
let showDates = false;
let showYears = false;


function check() {
  
  showMonths = false;
  showDates = false;
  showYears = false;
  
  birthdaySaved = false;
  
  if (year == "YYYY" || month == "MM" || date == "DD") return;
  
  toYoungErrorShown = false;
  
  // check to make sure that the birth day and month aren't younger than 18
  // start with all dates
  let datesPerMonthRange = 31;
  
  let curYear = new Date().getFullYear() - 18;
  if ( parseInt(year) == curYear ) {
    let curMonth = new Date().getMonth() + 1;
    let curDate = new Date().getDate();
    
    // two different scenarios to check
    if ( parseInt(month) > curMonth && parseInt(date) > curDate) {
      nextDisabled = true;
      toYoungErrorShown = true;
      return;
    }
    if ( parseInt(month) == curMonth && parseInt(date) > curDate) {
      nextDisabled = true;
      toYoungErrorShown = true;
      return;
    }
  }
  
  
  // construct the final date format
  birthday = year + "-" + 
    (month < 10 ? "0" + month : month) + "-" + 
    (date < 10 ? "0" + date : date);
  // console.log("birthday:", birthday);
  
  try {
    Validate.allowSignup(allowSignup);
    Validate.date(birthday);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
  
}


async function next() {
  
  if (birthdaySaved == false) {
    await Signup.saveToPersonalObject("birthday", birthday);
    await Signup.saveToPersonalObject("birthdaySaved", true);
    // since we haven't generated asymm keys yet, we'll wait to save this
    // await Signup.saveMe("birthday");
  }
  
  push("/signup/profile/personal/name");
}


</script>